import React from 'react'
import { AboutBrands } from '../../About/Brands'

const StatsSection: React.FC = () => {
  return (
    <section className='cooperation-banner' style={{ display: 'flex', alignItems: 'flex-start', margin: '60px auto 0 auto', padding: '40px 0', gap: '40px', maxWidth: '1200px', justifyContent: 'center', flexWrap: 'wrap' }}>
      {/* Lewa kolumna */}
      <div className='cooperation-left' style={{ flex: 1, minWidth: '280px', maxWidth: '600px', display: 'flex', flexDirection: 'column', gap: '24px', boxSizing: 'border-box', padding: '0 8px' }}>
        <h4 style={{ color: '#2e7d32', fontWeight: 600, fontSize: '1.1rem', marginBottom: '8px' }}>
          Udostępniaj produkty, oferuj usługi dla swojej grupy docelowej
        </h4>
        <h2 style={{ fontWeight: 700, fontSize: '2rem', marginBottom: '8px', color: '#222' }}>
          Dzięki naszej aplikacji możesz zaprezentować swoje produkty oraz usługi dokładnie tam, gdzie rodzą się wizje nowoczesnych wnętrz, ogrodów czy budynków – w pracowniach architektów, inżynierów i projektantów na całym świecie.
        </h2>
        <p style={{ fontSize: '1.05rem', color: '#444', lineHeight: 1.6, marginBottom: 0 }}>
          W świecie reklamy cyfrowej każde kliknięcie ma swoją cenę – ale nie każde ma wartość. Zamiast przepalać budżet na przypadkowe odsłony, postaw na środowisko, w którym Twoje produkty są wyszukiwane z intencją – przez projektantów, którzy właśnie tworzą projekt. Projektanci codziennie szukają nie tylko produktów, ale także zaufanych wykonawców, którzy pomogą im zrealizować konkretne projekty.<br /><br />Projektanci chcą pracować z rzetelnymi, sprawdzonymi wykonawcami.
        </p>
        {/* Zdjęcie z przyciskiem na nim */}
        <div style={{ position: 'relative', marginTop: 16, width: '100%', maxWidth: 420 }}>
          <img
            src='assets/images/about/singnture.png'
            alt='singnture'
          />
          <img src='assets/images/banners/11.jpg' alt='prezentacja' style={{ width: '100%', borderRadius: '12px', display: 'block' }} />
          <a href='https://www.youtube.com/watch?v=nrJtHemSPW4' target='_blank' rel='noopener noreferrer' style={{ position: 'absolute', left: 16, bottom: 16, display: 'inline-flex', alignItems: 'center', background: '#2e7d32', color: '#fff', fontWeight: 700, fontSize: '1.05rem', border: 'none', borderRadius: 8, padding: '16px 28px', boxShadow: '0 4px 16px rgba(46,125,50,0.18)', cursor: 'pointer', textDecoration: 'none' }}>
            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 32, height: 32, background: '#fff', borderRadius: '50%', marginRight: 16 }}>
              <svg width='18' height='18' viewBox='0 0 16 16' fill='#2e7d32' xmlns='http://www.w3.org/2000/svg'><polygon points='5,3 13,8 5,13' /></svg>
            </span>
            <span style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <span style={{ fontWeight: 700, fontSize: '1.08rem', color: '#fff', lineHeight: 1 }}>Watch Our<br />Presentation!</span>
            </span>
          </a>
        </div>
      </div>
      {/* Prawa kolumna */}
      <div style={{ flex: 1, minWidth: '280px', maxWidth: '480px', display: 'flex', flexDirection: 'column', gap: '32px', boxSizing: 'border-box', padding: '0 8px' }}>
        {/* Statystyki */}
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 600, marginBottom: 4 }}>
            <span>Precyzja dopasowania</span>
            <span style={{ color: '#2e7d32' }}>92%</span>
          </div>
          <div style={{ background: '#e0e0e0', borderRadius: 8, height: 10, width: '100%' }}>
            <div style={{ width: '92%', background: '#2e7d32', height: '100%', borderRadius: 8 }} />
          </div>
          <div style={{ fontSize: '0.98rem', color: '#555', marginTop: 6 }}>
            Nasze filtry dopasowują wyniki z zgodnością do potrzeb projektanta
          </div>
        </div>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 600, marginBottom: 4 }}>
            <span>Wskaźnik pobrań katalogów lub obiektów 3D</span>
            <span style={{ color: '#2e7d32' }}>67%</span>
          </div>
          <div style={{ background: '#e0e0e0', borderRadius: 8, height: 10, width: '100%' }}>
            <div style={{ width: '67%', background: '#2e7d32', height: '100%', borderRadius: 8 }} />
          </div>
          <div style={{ fontSize: '0.98rem', color: '#555', marginTop: 6 }}>
            Projektantów pobiera Twoje pliki w ciągu 7 dni od ich publikacji
          </div>
        </div>
        <div>
          <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 600, marginBottom: 4 }}>
            <span>Zaangażowanie użytkowników</span>
            <span style={{ color: '#2e7d32' }}>43%</span>
          </div>
          <div style={{ background: '#e0e0e0', borderRadius: 8, height: 10, width: '100%' }}>
            <div style={{ width: '43%', background: '#2e7d32', height: '100%', borderRadius: 8 }} />
          </div>
          <div style={{ fontSize: '0.98rem', color: '#555', marginTop: 6 }}>
            Odwiedzających Twoją stronę produktową klika przycisk 'dodaj do projektu'
          </div>
        </div>
        {/* Zdjęcie pod statystykami */}
        <div style={{ position: 'relative', marginTop: '32px' }}>
          <img src='assets/images/cooperation/Zd2.png' alt='zdj. 2' style={{ width: '100%', borderRadius: '12px', display: 'block' }} />
        </div>
      </div>
      <style>{`
        @media (max-width: 900px) {
          .cooperation-banner {
            flex-direction: column !important;
            gap: 24px !important;
            padding: 24px 0 !important;
          }
          .cooperation-left, .cooperation-banner > div {
            max-width: 100% !important;
            min-width: 0 !important;
            padding: 0 4vw !important;
          }
        }
        @media (max-width: 600px) {
          .cooperation-banner {
            padding: 10px 0 !important;
          }
          .cooperation-left, .cooperation-banner > div {
            padding: 0 2vw !important;
          }
          .cooperation-left h2 {
            font-size: 1.1rem !important;
          }
          .cooperation-left h4 {
            font-size: 1rem !important;
          }
        }
      `}
      </style>
    </section>
  )
}

export default StatsSection
